module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/fp/_falseOptions.js
// module id = 103
// module chunks = 0